import React, { useEffect, useState, useRef } from 'react'
import TextField from '@mui/material/TextField'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import AddCircleOutlineSharpIcon from '@mui/icons-material/AddCircleOutlineSharp'
import DoneOutlineSharpIcon from '@mui/icons-material/DoneOutlineSharp'
import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import { useSnackbar } from '../../alert/SnackbarProvider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import '../../styles/main.css'
import {
  updateData,
  addData,
  deleteData,
  getData,
  upsertDataTournaments,
  ids,
} from '../../api/indexedDBHandler'
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'
import DeleteIcon from '@mui/icons-material/Delete'
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency'

import Button from '@mui/material/Button'

import IconButton from '@mui/material/IconButton'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import Modal from '@mui/material/Modal'
import EditSharpIcon from '@mui/icons-material/EditSharp'
import CircularProgress from '@mui/material/CircularProgress'
import StarIcon from '@mui/icons-material/Star'
import ModalAddTeam from '../Modal/ModalAddTeam'

const TeamDrawCard = ({
  tournament,
  teamDataTemp,
  athleteDataTemp,
  typeDraw,
  response,
  typeCard,
  ids,
}) => {
  const { id } = useParams()
  const [sectorValue, setSectorValue] = useState('')
  const [color, setColor] = useState('Нет')

  const [openBackdrop, setOpenBackdrop] = useState(false)
  const [teamData, setteamData] = useState(null)
  const [athleteData, setathleteData] = useState(null)
  const [queue, setQueue] = useState('')
  //console.log('teamDataTemp', teamDataTemp.queue, ids)
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }
  const dob_sport_categori = (sports_category, dob) => {
    var arr = []
    if (sports_category) arr.push(sports_category)
    if (dob != '0000-00-00') arr.push(formatDateToDDMMYYYY(dob) + ' г.р.')
    return arr.join(', ')
  }
  const f_setQueue = (e) => {
    setQueue(e)
  }
  const inputRef = useRef(null) // Создаем ссылку

  const dellhandleClick = () => {
    console.log('dellhandleClick')
    response(null, ids, 'delQueue')
  }
  const dellhandleClickSector = () => {
    console.log('dellhandleClickSector')
    response(null, ids, 'delSector')
  }

  const handleClickSector = () => {
    // const sectorValue = inputRef.current.value

    if (sectorValue === '') {
      console.error('Номер сектора не может быть пустым!')
      return
    }

    // if (tournament.count_cups > 1 && color === 'Нет') {
    //   console.error('Выберите цвет сектора!')
    //   return
    // }

    // Отправляем данные (например, в API или родительский компонент)
    response(
      {
        sector: sectorValue,
        //color: tournament.count_cups > 1 ? color : null, // Если кубков <= 1, цвет не передаём
        color: null, // Если кубков <= 1, цвет не передаём
      },
      ids,
      'step'
    )

    console.log('Номер сектора:', sectorValue, 'Цвет:', color)
  }

  const handleClickSector2 = () => {
    const value = inputRef.current.value
    if (value != '') response(value, ids)
    console.log('Значение поля:', value)
  }

  const handleClickQueue = () => {
    const value = inputRef.current.value.replace(/\D/g, '')
    if (value != '' && value > 0) response(value, ids, 'delQueue')
    console.log('Значение поля:', value)
  }

  const name = () => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return teamData?.team_name_ru
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))
  useEffect(() => {
    setteamData(teamDataTemp)
  }, [teamDataTemp])

  useEffect(() => {
    console.log('athleteDataTemp', athleteDataTemp)
    setathleteData(athleteDataTemp)
  }, [athleteDataTemp])

  if (teamData)
    return (
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Grid size={{ xs: 12, md: 12 }}>
          <Item
            className="regateam"
            style={{
              padding: '18px',
            }}
          >
            <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
              {teamData?.logo && (
                <img
                  alt="Logo Team"
                  variant="square"
                  src={'https://protocarp.ru/' + teamData?.logo}
                  style={{ objectFit: 'contain !important', height: '40px' }}
                />
              )}
              <div>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ marginBottom: '0px', lineHeight: '1.2' }}
                  className="color-text-black"
                >
                  {name()}
                </Typography>
                <Typography variant="caption" gutterBottom>
                  {teamData.name}
                </Typography>
              </div>
            </Stack>
            <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
              <div>
                {athleteData.map((athlete, index) => (
                  <Stack
                    key={athlete.id}
                    direction="row"
                    spacing={2}
                    style={{ textAlign: 'left', paddingTop: '20px' }}
                  >
                    <div>
                      <Typography
                        variant="body1"
                        gutterBottom
                        style={{ marginBottom: '0px' }}
                        className="color-text-black"
                      >
                        {athlete.fio}{' '}
                        {athlete.identification == 'идентифицирован' ? (
                          <StarIcon
                            fontSize="small"
                            style={{ fill: '#2a52be' }}
                          />
                        ) : (
                          <></>
                        )}
                      </Typography>
                      <Typography
                        variant="caption"
                        gutterBottom
                        sx={{ display: 'block' }}
                      >
                        {dob_sport_categori(
                          athlete.sports_category,
                          athlete.dob
                        )}
                      </Typography>
                    </div>
                  </Stack>
                ))}
              </div>
              <Box sx={{ flexGrow: 1 }} />
              {typeCard === 'Rega' && (
                <div>
                  <div> НОМЕР ОЧЕРЕДИ: </div>
                  <div>
                    <TextField
                      inputRef={inputRef}
                      type="tel"
                      sx={{ marginBottom: 1, marginTop: 1 }}
                    />
                    <div style={{ textAlign: 'end' }}>
                      <Button
                        onClick={handleClickQueue}
                        variant="contained"
                        size="small"
                      >
                        Сохранить очередь
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {typeCard === 'Draw' && (
                <div>
                  <div>
                    <b>НОМЕР ОЧЕРЕДИ: {teamData.queue}</b>
                    <IconButton onClick={dellhandleClick}>
                      <DeleteIcon style={{ fill: 'red' }} />
                    </IconButton>
                  </div>
                  <div>ВВЕДИТЕ НОМЕР СЕКТОРА:</div>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <TextField
                      value={sectorValue}
                      onChange={(e) => setSectorValue(e.target.value)}
                      sx={{ mb: 1, mt: 1 }}
                    />
                    {/* {tournament.count_cups > 1 && (
                      <FormControl size="small" required>
                        <InputLabel>Цвет</InputLabel>
                        <Select
                          value={color}
                          onChange={(e) => setColor(e.target.value)}
                          label="Цвет"
                        >
                          <MenuItem value="Нет">Нет</MenuItem>
                          <MenuItem value="А">Красный</MenuItem>
                          <MenuItem value="Б">Синий</MenuItem>
                          <MenuItem value="В">Жёлтый</MenuItem>
                        </Select>
                      </FormControl>
                    )} */}
                  </div>
                  <Button
                    onClick={handleClickSector}
                    variant="contained"
                    color="success"
                  >
                    Сохранить сектор
                  </Button>
                </div>
              )}
              {typeCard === 'Sector' && (
                <div>
                  <div>
                    <b>НОМЕР ОЧЕРЕДИ: {teamData.queue}</b>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={dellhandleClick}
                    >
                      <DeleteIcon fontSize="inherit" style={{ fill: 'red' }} />
                    </IconButton>
                  </div>
                  <div>
                    <b>НОМЕР СЕКТОРА: {teamData.sector}</b>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={dellhandleClickSector}
                    >
                      <DeleteIcon fontSize="inherit" style={{ fill: 'red' }} />
                    </IconButton>
                  </div>
                  {/* {tournament.count_cups > 1 && <b>ЦВЕТ: {teamData.zona}</b>} */}
                </div>
              )}
            </Stack>
          </Item>
        </Grid>
      </>
    )
}

export default TeamDrawCard
